import React from 'react'
import { Container, Header, Button, Icon } from 'semantic-ui-react';
import Fade from 'react-reveal/Fade'
import '../styles/heroSection.scss';
import heroImage from '../images/hero-image2.jpg';

const heroStyles = {
  background: `linear-gradient(to right, rgba(63, 76, 107, 0.8), rgba(63, 76, 107, 0.8)),
    url('${heroImage}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',

};

const HeroSection = props => (
  <section id="home" className="content-deck hero" style={heroStyles}>
    <Container>
      <Fade right>
        <h1 className="hero__headline">PME-NA<sup>40</sup> 2018</h1>
      </Fade>
      <Fade left>
      <h2 className="hero__subhead">Looking Back, Looking Ahead: Celebrating 40 Years</h2>
        <Button target="_blank" href="https://s3.us-east-2.amazonaws.com/pmena2018/documents/public/PMENA+2018+Proceedings.pdf" size="large" inverted color="teal" className="hero__button">
        Conference Proceedings &nbsp; <Icon name='file pdf outline'/>
      </Button>
      </Fade>
    </Container>
  </section>
)

export default HeroSection



// WEBPACK FOOTER //
// ./src/sections/heroSection.js